var map = {
	"./en/settingPage": 93072,
	"./es/settingPage": 51403,
	"./fr/settingPage": 81295,
	"./hn/settingPage": 51009,
	"./pb/settingPage": 12117,
	"./rs/settingPage": 62324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80263;